export const MIN_SCALE_BY_CLIENT = 0.4;
export const SCALE_BY_CLIENT = 1.08;
export const MAX_SCALE_BY_CLIENT = 4;

export const MIN_SCALE_DETAIL_CLIENT = 1;
export const MAX_SCALE_DETAIL_CLIENT = 4;
